import { EMPTY_VALUE_DASH } from '../../../constants'
import { numberToCurrency } from '../../../utils'
import { TradeFormValues } from '../Types'
import { isBuy } from './isBuy'

export const getPrincipalAmount = ({ action, executionPrice, quantity }: TradeFormValues): number | undefined => {
  if (!action || !executionPrice || !quantity) return undefined
  return quantity * executionPrice * (isBuy(action) ? -1 : 1)
}

export const getPrincipalAmountString = (values: TradeFormValues): string => {
  const principalAmount = getPrincipalAmount(values)
  return principalAmount ? numberToCurrency(Math.abs(principalAmount), values.currency) : EMPTY_VALUE_DASH
}
